import {
  Collapse,
  Flex,
  FormControl,
  FormLabel,
  HStack,
  Heading,
  Input,
  Select,
  Stack,
  Tag,
  Text,
  Tooltip,
} from '@chakra-ui/react';
import { Field, Form, Formik } from 'formik';
import 'react-quill/dist/quill.snow.css';
import Button from '../../lead/shared/Button';
import Quill from './Quill';

const SendEmailForm = ({
  handleSendEmail,
  templateSubject,
  setHtmlBody,
  handleTemplateChange,
  showScheduler,
  templateValue,
  setSelectedDate,
  handleShowScheduler,
  localDeliveryTime,
  firstPortalInviteMutation,
  handleSendMagicLink,
  isLoading,
  handleSendFirstPortalInvite,
  invalidScheduleArgs,
  invalidEmailArgs,
  enabledTemplates,
  isFsm,
  setTemplateSubject,
  selectedTime,
  setSelectedTime,
  isDisabled,
}) => (
  <Formik initialValues={{ subject: templateSubject, date: null }} onSubmit={() => handleSendEmail()}>
    {(props) => (
      <Form>
        <Stack spacing="5" px={{ base: '4', md: '6' }} py={{ base: '5', md: '6' }}>
          <Field name="template" type="select">
            {() => (
              <FormControl>
                <FormLabel>Templates </FormLabel>
                <Select onChange={(e) => handleTemplateChange(e.target.value)} name="template">
                  {Object.keys(enabledTemplates).map((templateKey: string) => (
                    <option key={templateKey} value={templateKey}>
                      {enabledTemplates[templateKey].label}
                    </option>
                  ))}
                </Select>
              </FormControl>
            )}
          </Field>
          <Field name="subject">
            {() => (
              <FormControl>
                <FormLabel>Subject: </FormLabel>
                <Input onChange={(e) => setTemplateSubject(e.target.value)} value={templateSubject} name="subject" />
              </FormControl>
            )}
          </Field>
          <Field name="emailBody">
            {() => (
              <FormControl>
                <FormLabel>Email Body</FormLabel>
                <Quill templateValue={templateValue} setHtml={setHtmlBody} />
              </FormControl>
            )}
          </Field>
          <Flex>
            <Collapse in={showScheduler}>
              <HStack spacing={5}>
                <Field name="date">
                  {() => (
                    <FormControl>
                      <FormLabel>Date:</FormLabel>
                      <Input
                        type="date"
                        defaultValue={props.initialValues.date}
                        onChange={(e) => setSelectedDate(e.target.value)}
                        min={new Date().toISOString().split('T')[0]}
                      />
                    </FormControl>
                  )}
                </Field>
                <HStack spacing={5} mt={5}>
                  <FormControl>
                    <FormLabel>Hour:</FormLabel>
                    <Select
                      value={selectedTime.hour}
                      minWidth={20}
                      size="md"
                      width={10}
                      onChange={(e) => setSelectedTime({ ...selectedTime, hour: e.target.value })}
                      defaultValue={null}
                      isRequired={showScheduler}
                    >
                      <option value={null}>--</option>
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((val) => (
                        <option key={val} value={val.toString().padStart(2, '0')}>
                          {val.toString().padStart(2, '0')}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl>
                    <FormLabel>Minute:</FormLabel>
                    <Select
                      defaultValue={null}
                      value={selectedTime.minute}
                      minWidth={20}
                      size="md"
                      onChange={(e) => setSelectedTime({ ...selectedTime, minute: e.target.value })}
                      isRequired={showScheduler}
                    >
                      <option value={null}>--</option>
                      {[0, 1, 2, 3, 4, 5].map((val) => (
                        <option key={val} value={(val * 10).toString().padStart(2, '0')}>
                          {(val * 10).toString().padStart(2, '0')}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl>
                    <FormLabel>AM/PM:</FormLabel>
                    <Select
                      value={selectedTime.period}
                      minWidth={20}
                      size="md"
                      onChange={(e) => setSelectedTime({ ...selectedTime, period: e.target.value })}
                      defaultValue={null}
                      isRequired={showScheduler}
                    >
                      <option value={null}>--</option>
                      <option value="AM">AM</option>
                      <option value="PM">PM</option>
                    </Select>
                  </FormControl>
                </HStack>
              </HStack>
              {localDeliveryTime && (
                <Tag colorScheme="orange" mt={3}>
                  {localDeliveryTime ? `Scheduled For: ${localDeliveryTime}` : null}
                </Tag>
              )}
            </Collapse>
          </Flex>
          <Flex justifyContent="space-between">
            <HStack>
              <Button variant="solid" onClick={handleShowScheduler} isDisabled={isDisabled}>
                <Text>{showScheduler ? 'Close' : 'Schedule'}</Text>
              </Button>
              {firstPortalInviteMutation && (
                <Button
                  isLoading={isLoading}
                  onClick={handleSendFirstPortalInvite}
                  isDisabled={showScheduler || !isFsm || isDisabled}
                >
                  <Tooltip
                    placement="bottom"
                    label="Sends an email for client to login to the portal with information about parts A and B. For new to Medicare clients."
                    aria-label="Send Portal Invite Button"
                  >
                    <Text fontSize="md">Send First Portal Invite</Text>
                  </Tooltip>
                </Button>
              )}
              <Button aria-label="Send Magic Link" isLoading={isLoading} onClick={handleSendMagicLink}>
                <Tooltip
                  placement="bottom"
                  label="Sends a magic link to the client's email for login."
                  aria-label="Send Portal Invite Button"
                >
                  Send Magic Link
                </Tooltip>
              </Button>
            </HStack>
            <Button
              primary
              type="submit"
              isLoading={isLoading}
              isDisabled={invalidScheduleArgs || invalidEmailArgs || isDisabled}
            >
              {showScheduler ? 'Schedule Email' : 'Send Email'}
            </Button>
          </Flex>
        </Stack>
      </Form>
    )}
  </Formik>
);

export default SendEmailForm;
